import { PaymentMode } from "./InstallmentPayment.model";
export enum TransactionType {
  FEES_COLLECTION = "Fees",
}

export type TransactionFilterDialogValues = {
  startDate: any;
  endDate: any;
  paymentStartDate :any ;
  paymentEndDate :any ;
  transactionType: any[];
  account:any[];
  mode:any[]
};

export type TransactionListPropType = {
  _id: string;
  studentId: string;
  studentName:string ;
  amount: string | number;
  remark: string;
  mode: keyof typeof PaymentMode;
  type: keyof typeof TransactionType;
  accountId: string;
  paymentDate: string;
  isDeleted: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
  accountLabel: string;
};
